import React, {useEffect} from "react";
import styles from "./Stripe.module.css";
import Box from "@mui/material/Box";
import {useSectionsRefs} from "../../../components/mainWrapper/MainWrapper";
import StartStripeProces from "../../../components/stripe/startStripeProcessus/StartStripeProcess";

const Stripe = () => {

    const {
        setNavItems,
    } = useSectionsRefs();

    useEffect(() => {
        setNavItems([]);
    }, []);

    return (
        <div className={styles.container}>
            <Box sx={{
                width: "100%",
                backgroundColor: 'secondary.main',
                alignContent: 'center',
                height: "100%",
            }}>

                <Box
                    sx={{
                        backgroundColor: "secondary.main",
                        display: "flex",
                        justifyContent: "center",
                    }}
                >
                    <div className={styles.content}>
                        <div className={styles.realContent}>
                            <StartStripeProces/>
                        </div>
                    </div>

                </Box>

            </Box>
        </div>
    );
}

export default Stripe